class HeaderSearch {
  $btnSearchSpan = null
  $btnSearch = null
  $btnClose = null
  $searchInput = null
  $searchWrapper = null
  closed = true
  constructor () {
    this.init()
  }

  init () {
    console.log('header-serach init')
    this.$btnSearch = $('.navigation-principale-item .btn-search, .banner-mobile-search')
    this.$btnSearchSpan = $('.navigation-principale-item .btn-search span, .banner-mobile-search span')
    this.$btnClose = $('.navigation-search-wrapper .search-close')
    this.$searchInput = $('.navigation-search-wrapper .search-input')
    this.$searchWrapper = $('.navigation-search-wrapper')

    this.$btnSearch.click(() => {
      this.toggleViewSearch()
      this.focusSearchInput()
    })

    this.$btnClose.click(() => {
      this.$searchInput.val('')
    })

    $(document).on('menu-open', () => {
      console.log('menuopen triggered')
      if (!this.closed) {
        this.toggleViewSearch()
      }
    })
  }

  /* closeBtnSearchIcon () {
    this.$btnSearch.find('.btn-search-magnify').removeClass('hidden')
    this.$btnSearch.find('.btn-search-remove').addClass('hidden')
  } */

  toggleBtnSearchIcon () {
    this.$btnSearchSpan.toggleClass('hidden')
  }

  toggleViewSearch () {
    // console.log('toggle: ' + this.closed)
    if (this.closed) {
      $(document).trigger('search-open')
    }
    this.closed = !this.closed
    this.toggleBtnSearchIcon()
    this.$searchWrapper.slideToggle()
  }

  focusSearchInput () {
    this.$searchInput.focus()
  }
}

export default HeaderSearch
